export default {
  label: 'Date / Time',
  labelPosition: 'top',
  allowInput: true,
  format: 'dd-MM-yyyy hh:mm a',
  placeholder: 'dd-MM-yyyy hh:mm a',
  description: '',
  tooltip: '',
  customClass: '',
  hidden: false,
  hideLabel: false,
  disabled: false,
  enableDate: true,
  datePicker: {
    minDate: null,
    maxDate: null,
    showWeeks: true,
    startingDay: 0,
    initDate: '',
    minMode: 'day',
    maxMode: 'year',
    yearRows: 4,
    yearColumns: 5
  },
  enableTime: true,
  timePicker: {
    showMeridian: true,
    hourStep: 1,
    minuteStep: 1,
    readonlyInput: false,
    mousewheel: true,
    arrowkeys: true
  },
  validate: {
    required: false
  },
  widget: {
    type: 'calendar',
    allowInput: true,
    mode: 'single',
    enableTime: true,
    noCalendar: false,
    format: 'dd-MM-yyyy hh:mm a',
    hourIncrement: 1,
    minuteIncrement: 1,
    time_24hr: false,
    minDate: null,
    maxDate: null
  },
  key: 'dateTime',
  type: 'datetime',
  input: true,
  prefix: '',
  suffix: '<i ref="icon" class="fa fa-calendar" style=""></i>',
  datepickerMode: 'day',
  defaultValue: {
    type: 'value',
    value: ''
  },
  isNew: true,
  amsField: ''
};
